// TODO: Fix this
import TurndownService from "turndown";

// @ts-nocheck
import { getCollapsed } from "@/extensions/RoadmapList";

// import { isCollapsed } from "@/extensions/RoadmapList";

export const turndownService = new TurndownService();

turndownService.addRule("list", {
  filter: ["ul", "ol"],

  replacement: function (content, node) {
    var parent = node.parentNode;
    if (parent.nodeName === "LI" && parent.lastElementChild === node) {
      return "\n" + content;
    } else {
      return "\n\n" + content + "\n\n";
    }
  },
});

turndownService.addRule("listItem", {
  filter: "li",

  replacement: function (content, node, options) {
    const id = node.getAttribute("blockid");
    // const collapsed = getCollapsed(node.getAttribute("blockid"));
    // const isParentCollapsed = getCollapsed(
    //   node?.parentNode?.parentNode?.getAttribute("blockid")
    // );

    let a: Node = node;
    const els = [];
    let collapsed = false;
    while (a) {
      if (a && typeof a.getAttribute == "function") {
        const parentIsCollapsed = getCollapsed(a.getAttribute("blockid"));
        if (parentIsCollapsed) collapsed = true;
      }
      els.unshift(a);
      a = a?.parentNode;
    }
    // if (collapsed && node.querySelector("ul")) collapsed = false;
    // if (collapsed) return "";

    content = content
      .replace(/^\n+/, "") // remove leading newlines
      .replace(/\n+$/, "\n") // replace trailing newlines with just a single one
      .replace(/\n/gm, "\n    "); // indent
    // console.log(content);
    var prefix = options.bulletListMarker + "   ";
    var parent = node.parentNode;
    // console.log(
    //   "isParentCollapsed",
    //   getCollapsed(node?.parentNode?.parentNode?.getAttribute("blockid"))
    // );
    // console.log(node.nextSibling);
    if (parent?.nodeName === "OL") {
      var start = parent.getAttribute("start");
      var index = Array.prototype.indexOf.call(parent.children, node);
      prefix = (start ? Number(start) + index : index + 1) + ".  ";
    }
    // console.log(content);
    // console.log(
    //   collapsed ? content.replace(/\*\s+\(\|.*\|.*\|\): .*\n/gm, "") : content
    // );

    return (
      prefix +
      `(|${id}|${collapsed ? 1 : 0}|)` +
      ": " +
      (collapsed ? content.split(prefix + "(|")[0] : content) +
      (node.nextSibling && !/\n$/.test(content) ? "\n" : "")
    );
  },
});

export default turndownService;
